import { Component, OnInit } from '@angular/core';
import { FirebaseMessagingService } from '../../services/firebase-messaging/firebase-messaging.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
  fcmToken: string | null = null;
  permissionStatus: string = '';
  isLoading: boolean = false;
  showBanner: boolean = false;

  constructor(private firebaseMessaging: FirebaseMessagingService) {}

  ngOnInit(): void {
    this.checkNotificationPermission();
    this.firebaseMessaging.listenForMessages();
  }

  async enableNotifications(): Promise<void> {
    this.isLoading = true;
    try {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        this.fcmToken = await this.firebaseMessaging.getTokenIfPermitted();
        this.permissionStatus = 'Granted';
        this.showBanner = false;
      } else {
        this.permissionStatus = 'Denied';
        this.showBanner = true;
      }
    } catch (error) {
      console.error('Error requesting permission:', error);
      this.permissionStatus = 'Error';
      this.showBanner = true;
    } finally {
      this.isLoading = false;
    }
  }

  private checkNotificationPermission(): void {
    if ('Notification' in window) {
      this.permissionStatus = Notification.permission;
      this.showBanner = Notification.permission !== 'granted';
    } else {
      this.permissionStatus = 'Not supported';
      this.showBanner = false;
    }
  }

  closeBanner(): void {
    this.showBanner = false;
  }
}
